import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIcon = _resolveComponent("SIcon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_SIcon, {
              name: "custom:files/signed",
              class: "small-margin-right"
            }),
            _createVNode(_component_q_item_label, {
              class: "text-h6 base-margin-bottom",
              lines: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.signer.subjectName), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(" Выдан: " + _toDisplayString(_ctx.signer.issuerName) + ". ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" Действителен с " + _toDisplayString(_ctx.date(_ctx.signer.validFrom)) + " по " + _toDisplayString(_ctx.date(_ctx.signer.validTo)) + ". ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" Дата подписания: " + _toDisplayString(_ctx.date(_ctx.signer.signingTime)) + " ", 1),
              (_ctx.signer.comment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" Комментарий: " + _toDisplayString(_ctx.signer.comment), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}